/** Case-insensitive key for comparing recipient addresses. */
export const normalizeEmailKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const isInList = (email, list) =>
  list.some((entry) => normalizeEmailKey(entry) === normalizeEmailKey(email));

/**
 * Append the student/client email to Cc or Bcc without duplicating any To/Cc/Bcc entry.
 * @param {{ to?: string[], cc?: string[], bcc?: string[], studentEmail: string, placement?: 'CC'|'BCC' }} opts
 */
export const mergeNotifyStudentRecipient = ({
  to = [],
  cc = [],
  bcc = [],
  studentEmail,
  placement = "CC",
}) => {
  const email = String(studentEmail || "").trim();
  if (!email) {
    return { cc, bcc };
  }

  const existing = [...to, ...cc, ...bcc];
  if (isInList(email, existing)) {
    return { cc, bcc };
  }

  if (placement === "BCC") {
    return { cc, bcc: [...bcc, email] };
  }
  return { cc: [...cc, email], bcc };
};
